import { LottieLoader } from './LottieLoader'

type InfiniteLoaderProps = {
  variant?: 'white' | 'color'
  size?: number
  className?: string
  'aria-label'?: string
}

export function InfiniteLoader({ variant = 'white', size = 96, className, 'aria-label': ariaLabel = 'Loading' }: InfiniteLoaderProps) {
  const src = variant === 'color' ? '/animations/infinite-loader-color.lottie' : '/animations/infinite-loader.lottie'

  return (
    <LottieLoader
      ariaLabel={ariaLabel}
      autoplay
      className={className}
      fallbackClassName={variant === 'color' ? 'text-brand-500' : 'text-white'}
      loop
      size={size}
      src={src}
    />
  )
}
